/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percentage: NonNullable<unknown> }} Spaces_Sync_ProgressInputs */



/**
* | output |
* | --- |
* | "Syncing... {percentage}%" |
*
* @param {Spaces_Sync_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_sync_progress = /** @type {((inputs: Spaces_Sync_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Sync_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Synchronisiere... ${i?.percentage}%`)
	return /** @type {LocalizedString} */ (`Syncing... ${i?.percentage}%`)
});